export const SelectItems = [
    "All",
    "Anime",
    "Manga",
    "Characters",
    "People",
    "Companies",
    "Manga Store",
    "News",
    "Featured Articles",
    "Forum",
    "Clubs",
    "Users",
];
